import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { setDefByEntityType } from "../../getDefByEntityType";
import { IDefinition, IGetDefinition } from "../../PageUtils";
import { getCashReceiptsFormDef, getDefinitions as cashReceiptCommonDef } from "./CashReceiptsDef";
import CashReceiptsReceivedFormView from "./CashReceiptsReceivedFormView";

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const definition = cloneDeep(getCashReceiptsFormDef(CashReceiptsReceivedFormView, true, context));
    return definition;
};

getDefinitions.translationFiles = cashReceiptCommonDef.translationFiles;
setDefByEntityType(EntityTypeName.CashReceiptReceived, getDefinitions);